var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMaleWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0858 15.6691C10.9779 18.777 5.9389 18.777 2.83094 15.6691C-0.276997 12.5611 -0.276973 7.52212 2.83098 4.4142C5.70082 1.54433 10.2172 1.32449 13.3393 3.75464L15.6133 1.48055C15.6651 1.42875 15.6651 1.34476 15.6133 1.29297L14.961 0.64062C14.8829 0.562573 14.9288 0.428904 15.0383 0.415213L18.3516 0.00105092C18.4374 -0.00967778 18.5104 0.0632886 18.4997 0.149118L18.0855 3.4624C18.0718 3.57193 17.9381 3.61782 17.8601 3.53975L17.2078 2.8874C17.1559 2.83559 17.072 2.83559 17.0202 2.8874L14.7461 5.16161C17.1755 8.28368 16.9554 12.7995 14.0858 15.6691ZM4.23782 14.2622C6.56879 16.5932 10.348 16.5932 12.679 14.2622C15.01 11.9312 15.0099 8.15201 12.679 5.82108C10.348 3.4901 6.56879 3.49011 4.23782 5.82104C1.90687 8.15201 1.90687 11.9312 4.23782 14.2622Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMaleWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/male_white.d730cd2ecf43e1c3b373e316e09d7ca1.svg";